import {
  APPR_PARAM,
  DEPARTMENT,
  DESIGNATION,
  EMP_TYPE,
  EMPLOYMENT_STATUS,
  GRADES,
  OFFICE_LOCATION,
  POLICY,
  SETTINGS,
  SHIFTS,
  WEEKEND,
  HOLIDAY,
  CALENDAR,
  APPROVAL_WORKFLOW,
  COMP_OFF_CONFIG,
  EMP_CODE_CONFIG,
  SECTION,
  UNIT,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const SettingsRoutes: IAppRoutes = {
  link: SETTINGS,
  childrens: [
    {
      // internal alias for the department screen — gate it like DEPARTMENT (F8)
      link: POLICY,
      element: guard(() => import('@modules/settings/department'), [DEPARTMENT]),
    },
    {
      link: DEPARTMENT,
      element: guard(() => import('@modules/settings/department'), [DEPARTMENT]),
    },
    {
      link: DESIGNATION,
      element: guard(() => import('@modules/settings/designation'), [DESIGNATION]),
    },
    {
      link: EMP_TYPE,
      element: guard(() => import('@modules/settings/emp-type'), [EMP_TYPE]),
    },
    {
      link: EMPLOYMENT_STATUS,
      element: guard(() => import('@modules/settings/employment-status'), [EMPLOYMENT_STATUS]),
    },
    {
      link: GRADES,
      element: guard(() => import('@modules/settings/grades'), [GRADES]),
    },
    {
      link: SHIFTS,
      element: guard(() => import('@modules/settings/shifts'), [SHIFTS]),
    },
    {
      link: OFFICE_LOCATION,
      element: guard(() => import('@modules/settings/office-location'), [OFFICE_LOCATION]),
    },
    {
      link: APPR_PARAM,
      element: guard(() => import('@modules/settings/appraisal-param'), [APPR_PARAM]),
    },
    {
      link: WEEKEND,
      element: guard(() => import('@modules/settings/weekend'), [WEEKEND]),
    },
    {
      link: HOLIDAY,
      element: guard(() => import('@modules/settings/holiday'), [HOLIDAY]),
    },
    {
      link: CALENDAR,
      element: guard(() => import('@modules/settings/calendar'), [CALENDAR]),
    },
    {
      link: APPROVAL_WORKFLOW,
      element: guard(() => import('@modules/settings/approval-workflow'), [APPROVAL_WORKFLOW]),
    },
    {
      // Company compensatory-off policy. The back-end falls back to built-in defaults when no
      // row exists, so comp-off works before this screen is ever opened.
      link: COMP_OFF_CONFIG,
      element: guard(() => import('@modules/settings/comp-off-config'), [COMP_OFF_CONFIG]),
    },
    {
      // Company employee-code format. The back-end falls back to a built-in format when no row
      // exists, so codes are given before this screen is ever opened.
      link: EMP_CODE_CONFIG,
      element: guard(() => import('@modules/settings/employee-code'), [EMP_CODE_CONFIG]),
    },
    {
      link: SECTION,
      element: guard(() => import('@modules/settings/section'), [SECTION]),
    },
    {
      link: UNIT,
      element: guard(() => import('@modules/settings/unit'), [UNIT]),
    },
  ],
}
